export enum EDateFormat {
  FULL_DATE = 'DD MMMM YYYY',
  FULL_DATE_TIME = 'D MMMM YYYY hh:mm A',
  ISO = 'YYYY-MM-DD',
  ISO_TIME = 'YYYY-MM-DD HH:mm:ss',
  EXTENDED = 'DD MMM YYYY',
  SHORT_MONTH = 'DD MMMM',
  SHORT_DAY = 'D MMMM YYYY',
  TIME = 'hh:mm A',
  TIME_SHORT = 'HH:mm',
  SHORT_DATE = 'MM/DD/YYYY',
  VISIT_DATE = 'DD MMM, YYYY',
  CHART_DAY = 'DD MMM',
  SNAPSHOT_NAMING = 'YYYYMMDDTHHmmss',
}
